/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarModelDictionaryValueFromJSON, CarModelDictionaryValueToJSON, } from './';
export function CarMakeDictionaryValueFromJSON(json) {
    return CarMakeDictionaryValueFromJSONTyped(json, false);
}
export function CarMakeDictionaryValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'models': !exists(json, 'models') ? undefined : (json['models'] === null ? null : json['models'].map(CarModelDictionaryValueFromJSON)),
    };
}
export function CarMakeDictionaryValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'models': value.models === undefined ? undefined : (value.models === null ? null : value.models.map(CarModelDictionaryValueToJSON)),
    };
}
